export default "__VITE_ASSET__CvdOg0Jx__"